import React from "react";
import ReactDOM from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import "./lib/sentry";
import App from "./App.tsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";

import { registerZodErrorMap } from "@mebi/schemas";
import { initializeApiEnvironment } from "./lib/initializeApiEnvironment";

// Register global Zod error map for Vietnamese
registerZodErrorMap();

if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios") {
  document.body.classList.add("platform-ios-native");
}

const browserRouterFuture = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

const root = ReactDOM.createRoot(document.getElementById("root")!);

const renderApp = () => {
  root.render(
    React.createElement(
      React.StrictMode,
      null,
      React.createElement(
        BrowserRouter,
        { future: browserRouterFuture },
        React.createElement(App),
      ),
    ),
  );
};

void initializeApiEnvironment()
  .then(renderApp)
  .catch((error) => {
    console.error("Failed to initialize the API environment:", error);
    renderApp();
  });
